<script lang="ts">
import IconClose from 'virtual:icons/lucide/x'

import IconChevronDown from '@/components/icons/IconChevronDown.svelte'
import IconOptions from '@/components/icons/IconOptions.svelte'
import Tooltip from '@/components/Tooltip.svelte'
import { testIds } from '@/constants'
import IconButton from '@/core/IconButton.svelte'
import { closeMessengerFrame } from '@/modules/app'
import { assignedAgentIds, canCloseChat } from '@/modules/chat'
import { isFullScreenEnabled, isMobileDevice } from '@/modules/device'
import { DrawerId, openDrawer } from '@/modules/drawers'
import { widgetOptions } from '@/modules/options'
import { t } from '@/modules/translations'

type IconSize = 'md' | 'lg'

const { widgetBlockingOptions } = widgetOptions.getOptions()
let iconSize: IconSize = $derived($isFullScreenEnabled ? 'lg' : 'md')

// Render options always except case if on mobile device more than 1 agent is assigned
let shouldRenderOptions = $derived(!($isMobileDevice && $assignedAgentIds.length > 1))

const handleCloseButtonClick = () => {
	$canCloseChat ? openDrawer(DrawerId.CloseChat) : closeMessengerFrame()
}

const handleMinimazeChat = () => closeMessengerFrame()

const openOptions = () => {
	openDrawer(DrawerId.Options)
}

const { buttonOptions, buttonMinimizeChat, buttonCloseChat } = testIds
</script>

<div class="flex-center flex-shrink-0 overflow-hidden">
	{#if shouldRenderOptions}
		<Tooltip content={$t('tooltip.more')} placement="bottom" delay={1000}>
			<div class="ml-1">
				<IconButton
					icon={IconOptions}
					iconDescription="Options"
					onClick={openOptions}
					size={iconSize}
					testId={buttonOptions}
					disabled={widgetBlockingOptions?.disableOptionsButton}
				/>
			</div>
		</Tooltip>
	{/if}
	<Tooltip content={$t('tooltip.minimize')} placement="bottom" delay={1000}>
		<div class="ml-1">
			<IconButton
				icon={IconChevronDown}
				iconDescription="Minimize"
				onClick={handleMinimazeChat}
				size={iconSize}
				testId={buttonMinimizeChat}
				disabled={widgetBlockingOptions?.disableCloseButton}
			/>
		</div>
	</Tooltip>
	{#if $canCloseChat}
		<div class={{ 'animate-push-to-left': $canCloseChat }}>
			<Tooltip content={$t('tooltip.close')} placement="bottom" delay={1000}>
				<div class="ml-1">
					<IconButton
						icon={IconClose}
						iconDescription="Close"
						onClick={handleCloseButtonClick}
						size={iconSize}
						testId={buttonCloseChat}
						disabled={widgetBlockingOptions?.disableCloseButton}
					/>
				</div>
			</Tooltip>
		</div>
	{/if}
</div>
